export const EMPTY_STORAGE_REFERENCES = Object.freeze([]);

export const getStorageFileName = (path) => (
  String(path || '').split(/[\\/]/).filter(Boolean).pop() || 'Selected file'
);

export const getStorageReferenceLabel = (path) => {
  const segments = String(path || '').split(/[\\/]/).filter(Boolean);
  if (segments.length < 2) {
    return getStorageFileName(path);
  }

  return `${segments[segments.length - 2]} / ${segments[segments.length - 1]}`;
};

export const buildStorageReference = (path) => {
  const normalizedPath = String(path || '').trim();
  return {
    path: normalizedPath,
    label: getStorageReferenceLabel(normalizedPath),
  };
};
